function apiGetCall(apiname, params, cb) {
    if (Cookies.get("token")) {
        params["token"] = Cookies.get("token");
    }

    jQuery.post(
        localize.apiurl +
        "api/" +
        apiname +
        (window.debugerror == true ? "?error" : ""),
        params,
        function (result) {
            if (result.invalidtoken) {
                Cookies.remove("token");
                return cb("Munkamenet lejárt, kérjük jelentkezzen be újra.", result);
            }

            if (result.error) {
                cb(result.error, result);
            } else {
                cb(null, result);
            }
        },
        "json"
    );
}

(function ($) {
    if (Cookies.get("token")) {
        $('.js-menu-login-button').addClass('d-none');
        $('.js-menu-profil-button').removeClass('d-none');
    } else {
        $('.js-menu-login-button').removeClass('d-none');
        $('.js-menu-profil-button').addClass('d-none');
    }

    // handle logout
    $(".js-logout").click(e => {
        Cookies.remove("token");
        Cookies.remove("industries");
        window.location.href = localize.siteurl;
        e.preventDefault();
    });
})(jQuery);